module.exports = vendor_254ec79b9eff2627f00f;


//////////////////
// WEBPACK FOOTER
// external "vendor_254ec79b9eff2627f00f"
// module id = 56
// module chunks = 7 8